<template>
  <div>
    <v-card-title>{{ title }}</v-card-title>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "The title goes here - add dnf participants",
    };
  },
};
</script>
